import styled from 'styled-components'

export const CustomCytologyContainer = styled.div`
  margin-top: 2rem;

  div:not(:last-of-type) {
    margin-bottom: 2.5rem;
  }

  h4 {
    font-weight: 500;
    font-size: 20px;
    color: var(--grey2);
    margin-bottom: 1rem;
  }

  p {
    margin: 2rem 0;
    line-height: 22px;
  }

  ul {
    font-size: 16px;
    line-height: 22px;
    color: var(--grey2);
    list-style-position: inside;
  }
`
